import React from "react";

import { makeStyles } from "@material-ui/core/styles";
import { Stepper, StepConnector } from "@material-ui/core";

import { withStyles } from "@material-ui/styles";
import ICalloutRequestedStep from "./types/ICalloutRequestedStep";
import CalloutRequestedStep from "./CalloutRequestedStep";
import CalloutRequestedStepMobile from "./CalloutRequestedStepMobile";
import { activeCompletedColor, stepIconContainerSize, topLabelHeigh } from "./calloutRequestedData";

interface CalloutRequestedStepperProps {
  steps: ICalloutRequestedStep[];
  activeStepId: number;
  isCalloutFinished: boolean;
  eta: string;
}

const useStyles = makeStyles({
  desktopVerion: {
    "@media (max-width: 1023px)": {
      display: "none",
    },
  },
  mobileVersion: {
    "@media (min-width: 1024px)": {
      display: "none",
    },
    "@media (max-width: 600px)": {
      padding: 8,
    },
  },
  verticalConnector: {
    borderLeft: "3px solid white",
    opacity: "0.17",
    marginLeft: "24px",

    "@media (max-width: 600px)": {
      marginLeft: 16,
    },
  },
});

const createCalloutConnector = (isCallouFinished: boolean) =>
  withStyles({
    alternativeLabel: {
      top: topLabelHeigh + stepIconContainerSize / 2,
      left: `calc(-51% + ${stepIconContainerSize / 2}px)`,
      right: `calc(49% + ${stepIconContainerSize / 2}px)`,
    },
    // active: {
    //     '& $line': {
    //         borderColor: activeCompletedColor,
    //         opacity:'unset'
    //     },
    // },
    completed: {
      "& $line": {
        borderColor: isCallouFinished ? "white" : activeCompletedColor,
        opacity: isCallouFinished ? "0.54" : "unset",
      },
    },
    line: {
      borderColor: "white",
      borderTopWidth: 3,
      borderRadius: 1,
      opacity: "0.17",
    },
  })(StepConnector);

const CalloutRequestedStepper: React.FC<CalloutRequestedStepperProps> = ({ steps, activeStepId, isCalloutFinished, eta }) => {
  const classes = useStyles();
  const CalloutConnector = createCalloutConnector(isCalloutFinished);

  return (
    <>
      <Stepper connector={<CalloutConnector />} activeStep={activeStepId} alternativeLabel classes={{ root: classes.desktopVerion }}>
        {steps.map((step) => (
          <CalloutRequestedStep step={step} activeStepId={activeStepId} key={step.id} isCalloutFinished={isCalloutFinished} eta={eta} />
        ))}
      </Stepper>

      <Stepper
        connector={<StepConnector classes={{ vertical: classes.verticalConnector }} />}
        activeStep={activeStepId}
        orientation="vertical"
        classes={{ root: classes.mobileVersion }}
      >
        {steps.map((step) => (
          <CalloutRequestedStepMobile step={step} activeStepId={activeStepId} key={step.id} isCalloutFinished={isCalloutFinished} eta={eta} />
        ))}
      </Stepper>
    </>
  );
};

export default React.memo(CalloutRequestedStepper);
